import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-10" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  class: "d-flex",
  style: {"flex-direction":"column","width":"600px","height":"600px"}
}
const _hoisted_5 = { class: "mb-3 text-gray" }
const _hoisted_6 = { class: "p-field-checkbox d-flex align-items-center pl-2" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex flex-column align-items-center"
}
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "warning" }
const _hoisted_10 = { class: "warning" }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = {
  class: "d-flex flex-column",
  style: {"width":"200px"}
}
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "error" }, null, -1)
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "error" }
const _hoisted_18 = {
  key: 3,
  class: "d-flex flex-column"
}
const _hoisted_19 = { class: "align-items-center d-flex flex-column" }
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = { class: "warning" }
const _hoisted_22 = { class: "d-flex" }
const _hoisted_23 = { class: "ml-1" }
const _hoisted_24 = { class: "d-flex justify-content-between mb-5" }
const _hoisted_25 = { class: "text-gray" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "font-weight-bold" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isVisible = $event)),
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom dialog-edit-label"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, _toDisplayString(_ctx.subtitle), 1),
          (_ctx.dialogStep == 1)
            ? (_openBlock(), _createBlock(_component_ElScrollbar, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    class: "p-button-text p-0 mt-2 mb-2",
                    onClick: _ctx.selectAll
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("general.selectAll")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.disabledFlattenedList, (data, i) => {
                    return (_openBlock(), _createBlock("div", {
                      style: {"border-top":"solid 1px gray"},
                      key: i,
                      class: "selectable mr-2"
                    }, [
                      _createVNode("div", _hoisted_6, [
                        _createVNode(_component_Checkbox, {
                          modelValue: _ctx.selectedList,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedList = $event)),
                          value: data,
                          id: `checkbox-${i}`,
                          disabled: data.isDisabled
                        }, null, 8, ["modelValue", "value", "id", "disabled"]),
                        _createVNode("label", {
                          class: ["toSelect", { 'disabled-label': data.isDisabled }],
                          for: `checkbox-${i}`
                        }, _toDisplayString(_ctx.formatLabel(data)), 11, ["for"])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }))
            : (_ctx.dialogStep == 2)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("span", null, [
                    _createVNode(_component_InlineSvgScoped, {
                      style: {"color":"blue"},
                      src: 
                                require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                            ,
                      "aria-label": "icon-alert-medium-outline"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("incongruity")), 1),
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("incongruity.description", {
                                current: _ctx.apartmentsAlreadyCreatedCount,
                                imported: _ctx.selectedCount,
                            })), 1),
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("incongruity.confirm")), 1)
                ]))
              : (_ctx.dialogStep == 3)
                ? (_openBlock(), _createBlock("div", _hoisted_11, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedGrouped, (apartment, j) => {
                      return (_openBlock(), _createBlock("div", {
                        key: j,
                        class: "mb-4"
                      }, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(apartment.validLines, (line, index) => {
                              return (_openBlock(), _createBlock("span", {
                                key: index,
                                class: "d-block fw-bold lead"
                              }, [
                                _createVNode("span", null, _toDisplayString(line.Line1 != undefined
                                                ? line.Line1 + " "
                                                : ""), 1),
                                _createVNode("span", null, _toDisplayString(line.Line2 != undefined
                                                ? line.Line2
                                                : ""), 1)
                              ]))
                            }), 128))
                          ]),
                          _createVNode("div", _hoisted_14, [
                            _createVNode(_component_Dropdown, {
                              style: {"width":"200px"},
                              options: 
                                        _ctx.EntrancePlantDetail.buildings?.map(
                                            (building) => ({
                                                name: building.name?.trim(),
                                            })
                                        )
                                    ,
                              optionLabel: "name",
                              optionValue: "name",
                              modelValue: apartment.BuildingName,
                              "onUpdate:modelValue": ($event: any) => (apartment.BuildingName = $event),
                              onChange: ($event: any) => (_ctx.handleBuildingChange(apartment))
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onChange"]),
                            _hoisted_15
                          ]),
                          _createVNode("div", _hoisted_16, [
                            _createVNode(_component_Dropdown, {
                              style: {"width":"200px"},
                              options: 
                                        _ctx.selectApartmentsByBuilding(
                                            apartment.BuildingName
                                        )
                                    ,
                              optionLabel: "name",
                              optionValue: "name",
                              modelValue: apartment.ApartmentName,
                              "onUpdate:modelValue": ($event: any) => (apartment.ApartmentName = $event)
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                            _createVNode("span", _hoisted_17, _toDisplayString(!_ctx.isAvailable(
                                        apartment.BuildingName,
                                        apartment.ApartmentName,
                                        j
                                    )
                                        ? "errore"
                                        : ""), 1)
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_ctx.dialogStep == 4)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode(_component_InlineSvgScoped, {
                          style: {"color":"blue"},
                          src: 
                                require(`@/assets/images/icons/icon-alert-medium-outline.svg`)
                            ,
                          "aria-label": "icon-alert-medium-outline"
                        }, null, 8, ["src"]),
                        _createVNode("h2", _hoisted_20, _toDisplayString(_ctx.$t("warning")), 1),
                        _createVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("warning.description")), 1)
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.overwrited, (ap, i) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "d-flex flex-column aling-item-left mr-5 ml-5",
                          key: i
                        }, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("h6", null, _toDisplayString(_ctx.$t("AppResourceEP.Building")) + ": " + _toDisplayString(ap.BuildingName), 1),
                            _createVNode("h6", _hoisted_23, _toDisplayString(_ctx.$t("AppResourceEP.Apartment")) + ": " + _toDisplayString(ap.ApartmentName), 1)
                          ]),
                          _createVNode("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t("oldLines")) + ":", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(ap.OldLabel, (label, j) => {
                                return (_openBlock(), _createBlock("span", { key: j }, [
                                  _createTextVNode(_toDisplayString(label.Line1 != undefined
                                            ? label.Line1
                                            : "") + " " + _toDisplayString(label.Line2 != undefined
                                            ? label.Line2
                                            : "") + " ", 1),
                                  (j < ap.OldLabel.length - 1)
                                    ? (_openBlock(), _createBlock("span", _hoisted_26, ","))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _createVNode("div", _hoisted_27, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t("newLines")) + ":", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(ap.NewLabel, (label, j) => {
                                return (_openBlock(), _createBlock("span", { key: j }, [
                                  _createTextVNode(_toDisplayString(label.Line1 != undefined
                                            ? label.Line1
                                            : "") + " " + _toDisplayString(label.Line2 != undefined
                                            ? label.Line2
                                            : "") + " ", 1),
                                  (j < ap.NewLabel.length - 1)
                                    ? (_openBlock(), _createBlock("span", _hoisted_28, ","))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("footer", _hoisted_29, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleButtonCancelAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-rounded p-button-raised p-button--m",
          onClick: _ctx.handleButtonSubmitAction,
          disabled: _ctx.disableSaveButton
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}